export default "__VITE_ASSET__CZ4MlS5t__"